<template>
  <v-sheet
    :color="$vuetify.theme.isDark ? '#4C4C4C33' : '#fff'"
    style="box-shadow: 0px 0px 20px 0px #0000000d"
    class="pa-3 rounded-lg">
    <v-card-title class="d-flex justify-space-between pa-0">
      <span class="font-weight-bold" style="color: var(--v-grey-500-base)">{{ title }}</span>
    </v-card-title>
    <v-sheet
      :color="'transparent'"
      :height="canvasHeight"
      class="d-flex justify-center align-center">
      <canvas
        id="tempratureChart"
        style="width: 100%; max-width: 100%; height: auto; padding: 10px"></canvas>
    </v-sheet>
  </v-sheet>
</template>

<script>
  import Chart from 'chart.js/auto';

  export default {
    name: 'TemperatureChart',
    data() {
      return {
        chart: null,
      };
    },
    props: {
      title: String,
      canvasHeight: String,
      chartData: {
        type: Array,
        default: () => [],
      },
    },
    mounted() {
      const ctx = document.getElementById('tempratureChart').getContext('2d');
      const gradient = ctx.createLinearGradient(0, 0, 0, 200);
      gradient.addColorStop(0, 'rgba(168, 0, 0, 0.5)');
      gradient.addColorStop(1, 'rgba(168, 0, 0, 0.05)');

      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: [
            '12 AM',
            '2 AM',
            '4 AM',
            '6 AM',
            '8 AM',
            '10 AM',
            '12 PM',
            '2 PM',
            '4 PM',
            '6 PM',
            '8 PM',
            '10 PM',
          ],
          datasets: [
            {
              label: 'Temperature',
              backgroundColor: gradient,
              borderColor: '#A80000',
              borderWidth: 1,
              data: this.chartData,
              fill: true,
              tension: 0.4,
              pointBackgroundColor: '#fff',
              pointBorderColor: '#A80000',
              pointBorderWidth: 1,
              pointStyle: 'circle',
              pointRadius: 5,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              radius: 5,
              borderColor: '#A80000',
              borderWidth: 2,
            },
          },
          scales: {
            y: {
              min: 0,
              max: 100,
              ticks: {
                callback: function (value) {
                  return value + '°';
                },
              },
            },
          },
        },
      });
    },
    watch: {
      chartData: {
        handler: function (val) {
          this.chart.data.datasets[0].data = val;
          this.chart.update();
        },
        deep: true,
      },
    },
  };
</script>
